import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {},
  actions,
  mutations,
};
